import axios from 'axios'

import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor,
} from './interceptors'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)
instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor)

export default instance
